import React, { useState, useEffect, useContext } from 'react';

import { Routes, Route, Link, Navigate, useLocation, useNavigate } from 'react-router-dom';

import {

  Drawer,

  List,

  ListItem,

  ListItemIcon,

  ListItemText,

  Box,

  Divider,

  Collapse,

  IconButton

} from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';

import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

import ExpandLess from '@mui/icons-material/ExpandLess';

import ExpandMore from '@mui/icons-material/ExpandMore';

import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';

import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

import AssessmentIcon from '@mui/icons-material/Assessment';

import Perfil from '../pages/Dashboard/Perfil';

import Servicios from '../pages/Dashboard/Widget';

import WidgetStatistics from '../pages/Dashboard/WidgetStatistics';

import { useAuth } from '../contexts/AuthContext';

import { AWSContext } from '../contexts/AWSContext';

import Logo from '../assets/logo-viewser.png';

import Home from '../pages/Dashboard/Home';

import api from '../services/api';

import { useTranslation } from 'react-i18next';

import { LanguageContext } from '../contexts/LanguageContext';

import esFlag from '../assets/EsFlag.svg'; // Bandera de España

import enFlag from '../assets/EnFlag.svg'; // Bandera de Reino Unido (Inglés)

import ModificarPlanAWS from '../pages/Dashboard/ModificarPlanAWS';

import GuiaHtmlCss from './guias/GuiaHtmlCss';

import GuiaWordpress from './guias/GuiaWordpress';

import GuiaShopify from './guias/GuiaShopify';

import GuiaSquareSpace from './guias/GuiaSquareSpace';

import GuiaWebflow from './guias/GuiaWebflow';

import GuiaWix from './guias/GuiaWix';

import GuiaMagento from './guias/GuiaMagento';

import GuiaJoomla from './guias/GuiaJoomla';

import GuiaDrupal from './guias/GuiaDrupal';

import GuiaOpenCart from './guias/GuiaOpenCart';

import GuiaHubSpot from './guias/GuiaHubSpot';

import GuiaMoodle from './guias/GuiaMoodle';

import GuiaPrestaShop from './guias/GuiaPrestaShop';

import GuiaWeebly from './guias/GuiaWeebly';

import GuiaDuda from './guias/GuiaDuda';

import PersonalizarWidget from '../pages/Dashboard/PersonalizarWidget';

import EditarWidget from '../pages/Dashboard/EditarWidget';

import Noticias from '../pages/Dashboard/Noticias';

import Analizador from '../pages/Dashboard/Analizador';

import DetalleAnalisis from '../pages/Dashboard/DetalleAnalisis';

import NuevoAnalisis from '../pages/Dashboard/NuevoAnalisis';



const drawerWidth = 240;



const Dashboard = () => {

  const { user, signOut } = useAuth();

  const location = useLocation();

  const navigate = useNavigate();

  const [openProfile, setOpenProfile] = useState(false);

  const [customerName, setCustomerName] = useState('');

  const [openLanguage, setOpenLanguage] = useState(false);

  const { t } = useTranslation();

  const { language, changeLanguage } = useContext(LanguageContext);

  const { setIsAWS, setIsBig } = useContext(AWSContext);



  const fixedMenuIconRoutes = [

    '/dashboard',

    '/dashboard/guia-htmlcss',

    '/dashboard/guia-wordpress',

    '/dashboard/guia-shopify',

    '/dashboard/guia-squarespace',

    '/dashboard/guia-webflow',

    '/dashboard/guia-wix',

    '/dashboard/guia-magento',

    "/dashboard/guia-joomla",

    "/dashboard/guia-drupal",

    "/dashboard/guia-opencart",

    "/dashboard/guia-hubspot",

    "/dashboard/guia-moodle",

    "/dashboard/guia-prestashop",

    "/dashboard/guia-weebly",

    "/dashboard/guia-duda"

  ];



  // Verificar si la ruta actual está en las rutas con icono fijo o si comienza con /dashboard/

  const isMenuIconFixed = fixedMenuIconRoutes.includes(location.pathname) || location.pathname.startsWith('/dashboard/');



  const handleLogout = async () => {

    await signOut();

    navigate('/login');

  };



  const toggleDrawer = () => {

    setIsDrawerOpen(!isDrawerOpen);

  };



  const [isDrawerOpen, setIsDrawerOpen] = useState(window.innerWidth >= 900);

  const [isSmallScreen, setIsSmallScreen] = useState(false);



  useEffect(() => {

    // Detectar tamaño de pantalla

    const handleResize = () => {

      setIsSmallScreen(window.innerWidth < 900);

      setIsDrawerOpen(window.innerWidth >= 900);

    };



    window.addEventListener('resize', handleResize);

    handleResize(); // Llamamos a la función para verificar el tamaño al cargar la página



    return () => window.removeEventListener('resize', handleResize);

  }, []);



  useEffect(() => {

  const fetchBillingType = async () => {

    try {

      const response = await api.get(`/customer-billing-type/${user.id}`);

      

      // Compara el billingType obtenido y actualiza ambos flags

      const billingType = response.data.billingType;

      

      setIsAWS(billingType === 'AWS');

      setIsBig(billingType === 'Big');

      

      

    } catch (error) {

    }

  };



  fetchBillingType();

}, [user.id, setIsAWS, setIsBig]);



  useEffect(() => {

    const fetchCustomerName = async () => {

      try {

        const response = await api.get(`/customer-name/${user.id}`);

        setCustomerName(response.data.customerName);

      } catch (error) {

      }

    };



    const fetchData = async () => {

      await Promise.all([fetchCustomerName()]);

    };



    fetchData();

  }, [user.id]);



  if (!user) {

    return <Navigate to="/login" />;

  }



  const handleProfileClick = () => {

    setOpenProfile(!openProfile);

  };



  const handleOptionClick = () => {

    toggleDrawer();  // Esto cierra el Drawer

  };



  return (

    <Box sx={{ display: 'flex', minHeight: '100vh' }}>

      {/* Botón para abrir el Drawer en pantallas pequeñas */}

      <Box

        sx={{

          display: { xs: 'block', md: 'none' },

          position: isMenuIconFixed ? 'fixed' : 'absolute',

          top: { xs: '10px', sm: '6px' },

          left: '13px',

          zIndex: 1300,

        }}

      >

        <IconButton onClick={toggleDrawer}>

          <MenuIcon sx={{ fontSize: '32px', color: '#000' }} />

        </IconButton>

      </Box>



      <Drawer

        variant={isSmallScreen ? "temporary" : "permanent"}

        open={isDrawerOpen}

        onClose={toggleDrawer}

        sx={{

          width: isSmallScreen ? '100%' : drawerWidth,

          flexShrink: 0,

          '& .MuiDrawer-paper': {

            width: drawerWidth,

            boxSizing: 'border-box',

            display: 'flex',

            flexDirection: 'column',

            justifyContent: 'space-between',

            borderRight: '1px solid rgba(0, 0, 0, 0.08)',

            boxShadow: '2px 0px 8px rgba(0, 0, 0, 0.1)',

          },

        }}

      >

        <Box sx={{ mt: { xs: 5, md: 0 } }}>

          {/* Logo */}

          <Box sx={{ p: 2, textAlign: 'center' }}>

            <Box

              component="img"

              src={Logo}

              alt={t('LogoAlt')} // Traducción para el texto alternativo del logo

              sx={{ width: '140px', mb: 1, mt: 3, mr: 6 }}

            />

          </Box>

          {/* No hay Divider aquí */}



          {/* Links */}

          <List>

            <ListItem button component={Link} to="home" selected={location.pathname === '/dashboard/home'} onClick={handleOptionClick}>

              <ListItemIcon

                sx={{

                  minWidth: '30px',

                  marginRight: '8px',

                  marginLeft: '12px',

                }}

              >

                <img

                  src={

                    location.pathname === '/dashboard/home'

                      ? require('../assets/icono-viewser-activado.svg').default // SVG con color diferente

                      : require('../assets/icono-viewser.svg').default

                  }

                  alt={t('WidgetAlt')} // Traducción para el texto alternativo del ícono

                  style={{

                    width: '28px',

                    height: '28px',

                  }}

                />

              </ListItemIcon>

              <ListItemText

                primary={t('Inicio')}

                primaryTypographyProps={{

                  fontSize: '17px',

                  color: location.pathname === '/dashboard/home' ? '#000000' : '#4F4F4F',

                  fontWeight: 'normal'

                }}

              />

            </ListItem>



            <ListItem button component={Link} to="analizador" selected={location.pathname === '/dashboard/analizador'} onClick={handleOptionClick}>

              <ListItemIcon

                sx={{

                  minWidth: '30px',

                  marginRight: '6px',

                  marginLeft: '8px',

                }}

              >

                <AssessmentIcon

                  sx={{

                    width: '35px',

                    height: '35px',

                    color: location.pathname === '/dashboard/analizador' ? '#0F52BD' : '#4F4F4F',

                  }}

                />

              </ListItemIcon>

              <ListItemText

                primary={t('Analizador')}

                primaryTypographyProps={{

                  fontSize: '17px',

                  color: location.pathname === '/dashboard/analizador' ? '#000000' : '#4F4F4F',

                  fontWeight: 'normal'

                }}

              />

            </ListItem>



            {/* Divider después de Inicio - eliminamos la pestaña Widget */}

            {/* <Divider

              sx={{

                marginX: 2,

                backgroundColor: '#7894CC',

              }}

            /> */}



            {/* Selector de Idioma */}



          </List>

        </Box>



        <Box>

          <List>

            <Collapse in={openProfile} timeout="auto" unmountOnExit>

              <List component="div" disablePadding>

                <ListItem button component={Link} to="perfil" sx={{ pl: 4 }} selected={location.pathname === '/dashboard/perfil'} onClick={handleOptionClick}>

                  <ListItemIcon

                    sx={{

                      minWidth: '30px',

                      marginRight: '8px',

                    }}

                  >

                    <SettingsOutlinedIcon

                      sx={{

                        fontSize: '26px',

                        color: location.pathname === '/dashboard/perfil' ? '#0F52BD' : '#4F4F4F'

                      }}

                    />

                  </ListItemIcon>

                  <ListItemText

                    primary={t('Perfil')}

                    primaryTypographyProps={{

                      fontSize: '14px',

                      color: location.pathname === '/dashboard/perfil' ? '#000' : '#4F4F4F',

                    }}

                  />

                </ListItem>

                <ListItem button onClick={() => setOpenLanguage(!openLanguage)} sx={{ cursor: 'pointer' }}>

                  <ListItemIcon

                    sx={{

                      minWidth: '30px',

                      marginRight: '8px',

                      marginLeft: '12px',

                    }}

                  >

                    <LanguageOutlinedIcon

                      sx={{

                        fontSize: '26px',

                      }}

                    />

                  </ListItemIcon>

                  <ListItemText

                    primary={t('Language')}

                    primaryTypographyProps={{

                      fontSize: '14px',

                      color: '#4F4F4F',

                    }}

                  />

                  {openLanguage ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}

                </ListItem>

                <Collapse in={openLanguage} timeout="auto" unmountOnExit>

                  <List component="div" disablePadding>

                    <ListItem

                      button

                      sx={{ pl: 4, cursor: "pointer" }}

                      selected={language === 'es'}

                      onClick={() => {

                        changeLanguage('es');

                        setOpenLanguage(false);

                        handleOptionClick()

                      }}

                    >

                      <ListItemIcon sx={{ minWidth: '32px' }}> {/* Reduce el ancho del icono */}

                        <img src={esFlag} alt="Spanish" width={20} height={14} style={{ display: 'block' }} />

                      </ListItemIcon>

                      <ListItemText primary={t('Spanish')} />

                    </ListItem>

                    <ListItem

                      button

                      sx={{ pl: 4, cursor: "pointer" }}

                      selected={language === 'en'}

                      onClick={() => {

                        changeLanguage('en');

                        setOpenLanguage(false);

                        handleOptionClick()

                      }}

                    >

                      <ListItemIcon sx={{ minWidth: '32px' }}> {/* Reduce el ancho del icono */}

                        <img src={enFlag} alt="English" width={20} height={14} style={{ display: 'block' }} />

                      </ListItemIcon>

                      <ListItemText primary={t('English')} />

                    </ListItem>

                  </List>

                </Collapse>



                {/* Elimina el ListItem de Idioma duplicado si ya está arriba */}

                <ListItem

                  button

                  onClick={handleLogout}

                  sx={{

                    pl: 4,

                    cursor: 'pointer', // Cambia el cursor al de clic

                  }}

                >

                  <ListItemIcon

                    sx={{

                      minWidth: '30px', // Reduce el ancho mínimo del contenedor de icono para acercarlo al texto

                      marginRight: '8px',

                    }}

                  >

                    <LogoutOutlinedIcon

                      sx={{

                        fontSize: '26px',

                      }}

                    />

                  </ListItemIcon>

                  <ListItemText

                    primary={t('CerrarSesión')}

                    primaryTypographyProps={{

                      fontSize: '14px',

                      color: '#4F4F4F',

                    }}

                  />

                </ListItem>

              </List>

            </Collapse>



            {/* Botón de perfil */}

            <Divider

              sx={{

                marginX: 2, // Margen horizontal para acortar la línea

                backgroundColor: '#7894CC',

              }}

            />

            <ListItem button onClick={handleProfileClick} sx={{ cursor: 'pointer' }}>

              <ListItemIcon

                sx={{

                  minWidth: '30px', // Reduce el ancho mínimo del contenedor de icono para acercarlo al texto

                  marginRight: '8px',

                  marginLeft: '12px'

                }}

              >

                <PersonOutlineIcon

                  sx={{

                    fontSize: '32px', // Ajusta el tamaño a 24x24

                    color: '#000000',

                  }}

                />

              </ListItemIcon>

              <ListItemText

                primary={

                  customerName.length > 20

                    ? `${customerName.substring(0, 17)}...`

                    : customerName

                }

                primaryTypographyProps={{

                  fontSize: '17px',

                  color: '#000000',

                  style: {

                    whiteSpace: 'nowrap',

                    overflow: 'hidden',

                    textOverflow: 'ellipsis',

                    maxWidth: '200px', // Ajusta este valor según el diseño

                    display: 'block',

                  },

                }}

              />

              {openProfile ? <ExpandLess /> : <ExpandMore />}

            </ListItem>

          </List>

        </Box>

      </Drawer>



      <Box

        component="main"

        sx={{

          flexGrow: 1,

          bgcolor: 'background.default',

          p: { xs: 3, md: 3, lg: 3 },

          pr: { xs: 3, md: 0, lg: 3 },

          pl: { xs: 3, md: 3, lg: 3 },

          display: 'flex',

          flexDirection: 'column',

          overflow: 'hidden',

        }}

      >

        <Routes>

          <Route path="/" element={<Navigate to="home" />} />

          <Route path="home" element={<Home />} />

          <Route path="widget" element={<Servicios />} />

          <Route path="perfil" element={<Perfil />} />

          <Route path='modify-plan-aws' element={<ModificarPlanAWS />} />

          <Route path='widgets/:domain/estadisticas' element={<WidgetStatistics />} />

          <Route path="guia-htmlcss" element={<GuiaHtmlCss />} />

          <Route path="guia-wordpress" element={<GuiaWordpress />} />

          <Route path="guia-shopify" element={<GuiaShopify />} />

          <Route path="guia-squarespace" element={<GuiaSquareSpace />} />

          <Route path="guia-webflow" element={<GuiaWebflow />} />

          <Route path="guia-wix" element={<GuiaWix />} />

          <Route path="guia-magento" element={<GuiaMagento />} />

          <Route path="guia-joomla" element={<GuiaJoomla />} />

          <Route path="guia-drupal" element={<GuiaDrupal />} />

          <Route path="guia-opencart" element={<GuiaOpenCart />} />

          <Route path="guia-hubspot" element={<GuiaHubSpot />} />

          <Route path="guia-moodle" element={<GuiaMoodle />} />

          <Route path="guia-prestashop" element={<GuiaPrestaShop />} />

          <Route path="guia-weebly" element={<GuiaWeebly />} />

          <Route path="guia-duda" element={<GuiaDuda />} />

          <Route path="personalizar-widget" element={<PersonalizarWidget />} />

          <Route path="editar-widget" element={<EditarWidget />} />

          <Route path="noticias" element={<Noticias />} />

          <Route path="analizador" element={<Analizador />} />

          <Route path="analizador/:analysisSeq" element={<DetalleAnalisis />} />

          <Route path="analizador/nuevo" element={<NuevoAnalisis />} />

          <Route path="*" element={<Navigate to="home" />} />

        </Routes>

      </Box>

    </Box>

  );

};



export default Dashboard;
